<div class="policies-requests">
    <div class="policies align-items-right">
        <h3>Policies</h3>
        <div *ngFor="let quote of quotes; let i = index">
            <p class="item" [ngClass]="activeQuote(i) ? 'active' : ''" (click)="selectQuote(i)">
                {{ getQuoteName(quote) }}
            </p>
        </div>
    </div>
    <div class="request-content align-items-right">
        <h3>Requests</h3>
        <div>
            <p class="item m-0">
                <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}} Request for General Liability Quote">
                    General Liability Quote
                </a>
            </p>
        </div>
        <div>
            <p class="item m-0">
                <a href="{{wcCompQuoteUrl}}" target="_blank">
                    Work Comp Quote
                </a>
            </p>
        </div>
    </div>
</div>
